
import { Component, Prop, Vue } from 'vue-property-decorator'

import PayCashModel from '../models/PayCash'

import EButton from './Button.vue'
import EPaymentInfo from './PaymentInfo.vue'

@Component({
  components: {
    EButton,
    EPaymentInfo,
  },
})
export default class PayCash extends Vue {
  @Prop({ required: true }) readonly paycash!: PayCashModel
}
